<script>
    import { onMount } from "svelte";
    import { Router, Route } from "svelte-routing";
    import { initSentry } from "./sentryIntegraction.js";
    import Employee from "./routes/Employee.svelte";

    // Used for SSR. A falsy value is ignored by the Router.
    export let url = "";

    onMount(async () => {
        // Init Sentry reports
        initSentry();
    });
</script>
<Router url="{url}">
    <div>
        <Route path="employee/" component="{Employee}" />
    </div>
</Router>
